export default "__VITE_ASSET__BQ$wxOf1__"